import MyTicketsPage from './MyTicketsPage';
import { MyTicketsPageProps, MyTicketsPageValueProps } from './types';

export type { MyTicketsPageProps, MyTicketsPageValueProps };
export default MyTicketsPage;
